export default __webpack_public_path__ + "media/financial-cents-logo.1ef1c.png";